'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresProductInfoFlyer = function () {
    function WinresProductInfoFlyer($scope, scheduleService) {
        _classCallCheck(this, WinresProductInfoFlyer);

        this.$scope = $scope;
        this.scheduleService = scheduleService;
        this.destinationCode = this.resolve.item.destcode;
        this.productCode = this.resolve.item.prodcode;
        this.date = this.resolve.day.date;
        this.briefDescription = undefined;
        this.prices = undefined;
    }

    _createClass(WinresProductInfoFlyer, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.url = getHttpUrl(this.resolve.item.url);

            // init stuff here
            console.log("Product info modal init. Resolved item: ", this.resolve);
            this.scheduleService.getWeekScheduleItemInfo(this.destinationCode, this.productCode, this.date).then(function (response) {
                console.log("getWeekScheduleItemInfo response: ", response);
                _this.briefDescription = response.Headline;
                _this.prices = response.Prices;
            }).catch(function (error) {
                console.error("getWeekScheduleItemInfo error:", error);
            });
        }
    }, {
        key: 'formatFinnishDate',
        value: function formatFinnishDate(date) {
            return (0, _utils2.formatFinnishDatePretty)(date);
        }
    }]);

    return WinresProductInfoFlyer;
}();

function getHttpUrl(url) {
    // Special handling for /en/ language type href
    // Add language to reservation link
    // <host>/<pathname> -> <host>/en/<pathname>
    var params = window.location.pathname.split('/');

    // Assuming language is two chars
    if (params[1].length === 2) {
        var urlParams = url.split('/');

        // Insert language after host
        urlParams.splice(3, 0, params[1]);

        url = urlParams.join('/');
    }

    if (!window.location.href.startsWith('https')) return url.replace('https', 'http');
    return url;
}

WinresProductInfoFlyer.$inject = ['$scope', 'scheduleService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'WinresProductInfoFlyer';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('WinresProductInfoFlyer', require('./winresProductInfoFlyer.html'));
}]);

_module3.default.component('winresProductInfoFlyer', {
    templateUrl: getTemplate,
    controller: WinresProductInfoFlyer,
    bindings: {
        modalInstance: "<",
        resolve: "<"
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresProductInfoFlyer/winresProductInfoFlyer.js
// module id = 499
// module chunks = 2